export const CONTENT_MAX_WIDTH = '1260px';
export const CONTENT_MIN_WIDTH = '390px';
export const CONTENT_PADDING_X = '24px';


